import React, { useRef } from "react";
import { Link } from "react-router-dom";
import ShopProductCard from "./ShopProductCard";

export default function ProductCarousel({ title, products = [], seeAllLink }) {
  const carouselRef = useRef(null);

  const scrollByCard = (direction) => {
    const element = carouselRef.current;
    if (!element) return;

    const firstCard = element.querySelector("[data-card]");
    if (!firstCard) return;

    const gap = parseFloat(getComputedStyle(element).columnGap) || 0;
    const amount = (firstCard.offsetWidth + gap) * direction;

    element.scrollBy({
      left: amount,
      behavior: "smooth",
    });
  };

  return (
    <section className="w-full">
      <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div className="flex items-center justify-between gap-3 border-b border-gray-100 px-4 py-4 sm:px-5">
          <div className="min-w-0">
            {seeAllLink ? (
              <Link
                to={seeAllLink}
                className="inline-flex min-w-0 items-center text-gray-800 transition-colors hover:text-[#1E3A5F]"
              >
                <h2 className="truncate text-sm font-semibold sm:text-base">
                  {title}
                </h2>
              </Link>
            ) : (
              <h2 className="truncate text-sm font-semibold text-gray-800 sm:text-base">
                {title}
              </h2>
            )}
          </div>

          {seeAllLink && (
            <Link
              to={seeAllLink}
              className="shrink-0 text-xs font-medium text-[#00AFA9] transition-colors hover:text-[#00938E] sm:text-sm"
            >
              مشاهده همه
            </Link>
          )}
        </div>

        <div className="relative px-3 py-3 sm:px-5 sm:py-5">
          {products.length > 0 ? (
            <div className="relative">
              <div
                ref={carouselRef}
                className="no-scrollbar flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-smooth pb-1 sm:gap-4"
                style={{
                  WebkitOverflowScrolling: "touch",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                {products.map((product) => (
                  <div
                    key={product.id}
                    data-card
                    className="
                      w-[calc(50%-6px)]
                      shrink-0
                      snap-start
                      sm:w-[calc(33.333%-10.667px)]
                      md:w-[calc(25%-12px)]
                      lg:w-[calc(20%-12.8px)]
                    "
                  >
                    <Link
                      to={`/shopping/product-detail/${product.slug}`}
                      className="block h-full"
                    >
                      <ShopProductCard product={product} />
                    </Link>
                  </div>
                ))}
              </div>

              {products.length > 4 && (
                <>
                  <button
                    type="button"
                    onClick={() => scrollByCard(-1)}
                    aria-label="محصولات قبلی"
                    className="absolute left-2 top-1/2 z-10 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-lg border border-gray-300 bg-white text-[#1E3A5F] transition-colors hover:border-[#1E3A5F] hover:bg-gray-50 lg:flex"
                  >
                    <svg
                      className="h-5 w-5 rotate-180"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </button>

                  <button
                    type="button"
                    onClick={() => scrollByCard(1)}
                    aria-label="محصولات بعدی"
                    className="absolute right-2 top-1/2 z-10 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-lg border border-gray-300 bg-white text-[#1E3A5F] transition-colors hover:border-[#1E3A5F] hover:bg-gray-50 lg:flex"
                  >
                    <svg
                      className="h-5 w-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </button>
                </>
              )}
            </div>
          ) : (
            <div className="py-10 text-center text-sm text-gray-500">
              محصولی برای نمایش وجود ندارد
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
